<template>
  <div class="grid-item bg-base rounded-2 pa-3 flex flex-col gap-1 relative">
    <div class="absolute top-2 right-2 w-9 h-9 flex items-center justify-center rounded-5 bg-base">
      <CButton
        v-tooltip="isDeleteDisabled ? deleteDisabledTooltip : ''"
        circle
        :disabled="!canDelete || isDeleteDisabled"
        secondary
        type="error"
        @click.stop="emit('itemDeleted', item)"
      >
        <template #icon>
          <CIcon icon="trash" size="16px" />
        </template>
      </CButton>
    </div>

    <CImage
      class="rounded-2"
      height="135"
      :img-props="{ draggable: false }"
      lazy
      object-fit="cover"
      preview-disabled
      :src="thumbnailUrl"
      :style="{
        background: themeVars.primary6,
        border: `1px solid ${themeVars.primary6}`,
      }"
      width="240"
    />

    <div class="text-truncate max-w-[240px] font-700 text-center">
      {{ item.name }}
    </div>
    <div class="text-truncate text-center" :style="{ color: themeVars.text3 }">
      {{ item.content_extension?.toUpperCase() }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject, computed, type Ref } from 'vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CImage from '@lib/components/CImage/CImage.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import tooltipDirective from '@lib/directives/tooltip'
import type { File, User } from '@openapi'
import type { PitcherInfo } from '@lib/types/app'

interface GridItemProps {
  item: File
  isDeleteDisabled?: boolean
  deleteDisabledTooltip?: string
}

const props = withDefaults(defineProps<GridItemProps>(), {
  item: () => ({}) as File,
  isDeleteDisabled: false,
  deleteDisabledTooltip: '',
})

const emit = defineEmits(['itemDeleted'])

const myUser = inject<Ref<User | null>>(
  'myUser',
  computed(() => null),
)
const pitcherInfo = inject<Ref<PitcherInfo | null>>(
  'pitcherInfo',
  computed(() => null),
)

const vTooltip = tooltipDirective
const themeVars = useThemeVars()

const canDelete = computed(() => {
  const isOwner = props.item.created_by?.id === myUser.value?.id
  const isAdmin = pitcherInfo.value?.isAnyTypeOfAdmin || pitcherInfo.value?.isOrgAdmin || false
  return isOwner || isAdmin
})

const thumbnailUrl = computed(() => props.item.thumbnail_url || props.item.content_url || '')
</script>
